import StoredLayout from '../../layouts/StoredLayout'
import TextWidgets from './TextWidgets'
export default StoredLayout(TextWidgets)



// WEBPACK FOOTER //
// ./src/widgets/text-widgets/index.js